{
  "userSettings": {
    "title": "My Settings",
    "description": "Manage your personal profile and preferences",
    "tabs": {
      "profile": "Profile",
      "preferences": "Preferences",
      "security": "Security"
    },
    "profile": {
      "firstName": "First Name",
      "lastName": "Last Name",
      "email": "Email",
      "emailHelper": "Contact your organization manager to change your email",
      "role": "Job title",
      "roleHelper": "Contact your organization manager to change your job title",
      "department": "Department",
      "departmentHelper": "Contact your organization manager to change your department",
      "status": "Account Status",
      "organizationInfo": "Organization Information",
      "updateSuccess": "Profile updated successfully",
      "updateError": "Failed to update profile"
    },
    "preferences": {
      "language": "Language",
      "languageHelper": "Choose your preferred language for the interface"
    },
    "security": {
      "currentPassword": "Current Password",
      "newPassword": "New Password",
      "confirmPassword": "Confirm New Password",
      "changePassword": "Change Password",
      "passwordSuccess": "Password changed successfully",
      "passwordError": "Failed to change password",
      "invalidCurrentPassword": "Current password is incorrect",
      "passwordRequirements": "Password Requirements",
      "minLength": "At least 8 characters long",
      "requireLowercase": "At least one lowercase letter (a-z)",
      "requireUppercase": "At least one uppercase letter (A-Z)",
      "requireNumber": "At least one number (0-9)",
      "twoFactorTitle": "Two-Factor Authentication (2FA)",
      "twoFactorDescription": "Protect your account with a one-time code from an authenticator app.",
      "twoFactorEnabled": "Two-factor authentication is active",
      "setupTwoFactor": "Set up 2FA",
      "scanQrCode": "Scan this QR code with your authenticator app, then enter the 6-digit code below.",
      "manualSecret": "Can't scan? Show the secret for manual entry",
      "codeLabel": "6-digit code",
      "verifyCode": "Verify code",
      "removeTwoFactor": "Remove 2FA",
      "removeTwoFactorConfirm": "Your account will no longer require a one-time code at sign-in. Are you sure?",
      "twoFactorSetupSuccess": "Two-factor authentication enabled",
      "twoFactorSetupError": "Setting up two-factor authentication failed",
      "twoFactorRemoveSuccess": "Two-factor authentication removed",
      "twoFactorRemoveError": "Removing two-factor authentication failed",
      "ssoManagedTitle": "Managed by your organization",
      "ssoManagedDescription": "Your password and two-factor authentication are managed by {{idpName}}.",
      "ssoManagedFallbackIdp": "your organization's identity provider",
      "passwordUnavailable": "Password changes are not available for your account yet. Sign in via single sign-on once, or contact your administrator.",
      "noPasswordSet": "No password is set for this account, so there is no password to change.",
      "statusError": "Security settings could not be loaded.",
      "passkeysTitle": "Passkeys",
      "passkeysDescription": "Sign in without a password using Face ID, Touch ID, or a hardware security key.",
      "addPasskey": "Add passkey",
      "unnamedPasskey": "Passkey",
      "removePasskey": "Remove passkey",
      "removePasskeyConfirm": "This passkey can no longer be used to sign in. Are you sure?",
      "passkeyRemoveSuccess": "Passkey removed",
      "passkeyRemoveError": "Removing the passkey failed",
      "reauthenticate": "Confirm sign-in",
      "passkeyLinkError": "Starting passkey setup failed",
      "passkeyPopupBlocked": "Your browser blocked the passkey setup tab. Please allow pop-ups for this page and try again.",
      "stepUpTitle": "Recent sign-in required",
      "stepUpDescription": "For your security, changes to sign-in settings require a recent sign-in. You will be redirected to confirm your sign-in and then returned here.",
      "stepUpPasskeyDescription": "For your security, adding a passkey requires a recent sign-in. After confirming your sign-in, click \"Add passkey\" again.",
      "stepUpSignInAgain": "For your security, this change requires a recent sign-in. Please sign out, sign in again, and then retry."
    }
  },
  "adminSettings": {
    "tenant": {
      "tabUsers": "Users",
      "tabSettings": "Settings",
      "slug": "Slug: {{slug}}",
      "addUser": "Add User",
      "columnName": "Name",
      "columnEmail": "Email",
      "columnUserTypes": "User Types",
      "columnStatus": "Status",
      "columnClassification": "Classification",
      "sendInvitationAction": "Send Invitation",
      "resendInvitationAction": "Resend Invitation",
      "copyActivationLinkAction": "Copy Activation Link",
      "copyActivationLinkSuccess": "Activation link copied to clipboard",
      "copyActivationLinkFailed": "Failed to generate activation link",
      "copyActivationLinkManual": "Copy this activation link manually",
      "resetSignInFailed": "Failed to reset sign-in",
      "deleteUserTitle": "Delete User",
      "deleteUserDescription": "Are you sure you want to delete this user? This action cannot be undone.",
      "deleteUserSuccess": "User deleted successfully",
      "deleteUserFailed": "Failed to delete user",
      "sendInvitationSuccess": "Invitation sent successfully",
      "sendInvitationFailed": "Failed to send invitation",
      "createdButInvitationFailed": "User created, but the invitation could not be sent — use \"Resend Invitation\" to retry",
      "externalOrgRequired": "External organization is required for external users",
      "aiTitle": "AI Features",
      "aiDescription": "Control whether AI features are available for this tenant.",
      "enableAILabel": "Enable AI",
      "enableAIDescription": "Master toggle for all AI features of this tenant, such as Bliksy, step summary and dictation. Applies to customer and partner tenants.",
      "saved": "Tenant settings saved.",
      "saveFailed": "Failed to save tenant settings.",
      "tabApps": "Apps",
      "tabUsage": "Usage",
      "appsDescription": "Manage which apps this tenant has.",
      "addAppSuccess": "App added successfully.",
      "addAppFailed": "Failed to add app.",
      "removeAppSuccess": "App removed successfully.",
      "removeAppFailed": "Failed to remove app.",
      "addApp": "Add app",
      "addAppNoCandidates": "No further apps are available to add.",
      "noAppsAdded": "No app has been added to this tenant yet.",
      "appAllowed": "May use this app",
      "appAllowedSaved": "Permission saved.",
      "appAllowedSaveFailed": "Failed to save the permission.",
      "appSeats": "Seats",
      "appSeatLimit": "Seat limit",
      "seatLimitSaved": "Seat limit saved.",
      "seatLimitSaveFailed": "Failed to save seat limit.",
      "removeAppTitle": "Remove app",
      "removeAppConfirm": "Removing this app discards its per-tenant configuration and releases all assigned seats. Adding it again does not restore them.",
      "removeApp": "Remove from tenant",
      "appConfig": "Configuration",
      "appConfigPlannerEnabled": "Measure project planner",
      "appConfigSalesPartnerCompanyId": "Partner's HubSpot company",
      "appConfigSalesPartnerCompanyIdHint": "The partner sees only the leads this company's employees brought in. Maintained on the tenant, not here.",
      "appConfigSalesPartnerCompanyIdMissing": "No HubSpot company is linked to this tenant: the partner sees no leads and cannot report any. Set it on the General tab.",
      "appConfigUnreadable": "Stored configuration cannot be read; saving replaces it.",
      "appConfigure": "Configure",
      "appConfigTitle": "App configuration",
      "appConfigUnreadableDialog": "A stored configuration exists but cannot be read with the current schema. It is not shown here, and saving replaces it.",
      "appConfigNorms": "Norms",
      "appConfigNormsPlaceholder": "Select norms",
      "appConfigRequestAllowance": "Requests per contract year",
      "appConfigContractAnchor": "Contract start",
      "appConfigContractAnchorPick": "Pick a date",
      "appConfigContractAnchorPopup": "Contract start calendar",
      "appConfigContractAnchorFuture": "The contract start may not be in the future.",
      "appConfigSaved": "Configuration saved.",
      "appConfigSaveFailed": "Failed to save the configuration.",
      "provisioningTitle": "Set up workspaces for others",
      "provisioningDescription": "Which kinds of workspace this partner may set up for others and then manage, e.g. from the sales app. With none selected it may set up none."
    },
    "globalAi": {
      "title": "AI Model Settings",
      "description": "Configure the AI models used across all tenants.",
      "highModelLabel": "High Tier Model",
      "highModelDescription": "AI model used for complex tasks (Bliksy agent, Omniscient).",
      "lowModelLabel": "Low Tier Model",
      "lowModelDescription": "AI model used for simple tasks (step summaries, Bliksy sub-tasks).",
      "transcriptionModelLabel": "Transcription Model",
      "transcriptionModelDescription": "Model used for voice-to-text transcription.",
      "saved": "AI model settings saved.",
      "saveFailed": "Failed to save AI model settings.",
      "featureOverride": {
        "title": "Per-feature Overrides",
        "description": "Optionally pin a feature to a specific model or tier. By default, each feature follows its assigned tier.",
        "tier": {
          "high": "High tier",
          "low": "Low tier",
          "decision": "Decision tier"
        },
        "bliksy-chat": {
          "label": "Bliksy chat",
          "description": "Interactive recording assistant agent."
        },
        "bliksy-modify-subagent": {
          "label": "Bliksy modify sub-agent",
          "description": "Sub-agent that applies structured step modifications inside Bliksy."
        },
        "step-summary": {
          "label": "Step summary",
          "description": "Generates step names and descriptions after a recording finishes."
        },
        "chat-title": {
          "label": "Chat title generation",
          "description": "Generates short titles for chat sessions."
        },
        "chat-summarizer": {
          "label": "Conversation summarizer",
          "description": "Compacts long chats into a rolling summary."
        },
        "decision-eval-judge": {
          "label": "Decision judge (evals)",
          "description": "Scores evaluation runs with graded questions."
        }
      },
      "appOverride": {
        "title": "App Models"
      },
      "reasoning": {
        "label": "Reasoning effort",
        "effort": {
          "none": "Off",
          "low": "Low",
          "medium": "Medium",
          "high": "High",
          "xhigh": "Extra high",
          "max": "Max"
        }
      }
    },
    "superAdmin": {
      "title": "User Management",
      "description": "Manage superadmin users in the system",
      "inviteUser": "Invite User",
      "errorLoadingUsers": "Error loading users",
      "columnEmail": "Email",
      "columnFirstName": "First Name",
      "columnLastName": "Last Name",
      "columnStatus": "Status",
      "columnInvited": "Invited",
      "columnActivated": "Activated",
      "inviteTitle": "Invite SuperAdmin User",
      "inviteDescription": "Send an invitation to a new superadmin user. They will receive an email with instructions to activate their account.",
      "inviteSend": "Send Invitation",
      "firstNameRequired": "First name is required",
      "lastNameRequired": "Last name is required",
      "emailRequired": "Email is required",
      "emailInvalid": "Invalid email address",
      "role": "Role",
      "roles": {
        "platform_admin": "Platform administration",
        "platform_support": "Support"
      },
      "roleHint": {
        "platform_admin": "May do everything: catalogue, users, settings, deletion.",
        "platform_support": "Reads accounts, the workspace list and logs — changes nothing."
      },
      "roleNone": "No role",
      "noAccessTitle": "No area enabled",
      "noAccessBody": "This account belongs to the platform but carries no role. A platform administrator can assign one in user management.",
      "rolePlaceholder": "Choose a role",
      "roleRequired": "Please choose a role.",
      "changeRole": "Change role",
      "changeRoleTitle": "Change role",
      "changeRoleDescription": "What {{name}} may do on the platform.",
      "changeRoleSave": "Save"
    }
  }
}
